import {  Button, styled } from "@mui/material"

export const AddNewResourceButtonWrapper: any = styled(Button)({
  height: "40px",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  borderRadius: "4px",
  cursor: "pointer",

  border: "1px solid #fff",
  "&:disabled": {
    color: "#FFFFFF",
    backgroundColor: "#707070",
  },
})
